import styled, { createGlobalStyle } from 'styled-components'

export const Container = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  box-sizing: border-box;

  max-height: 650px;
  min-height: 550px;

  height: auto;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    gap: 16px;
    /* padding: 16px; */
    /* margin-bottom: var(--safe-area-inset-bottom, 16px); */
    max-height: unset;
  }
`

export const Title = styled.div`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    font-weight: 400;
  }
`

export const GlobalStyle = createGlobalStyle`
  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    iframe {
      height: auto !important;
      border-radius: 6px;
      border: 1px solid var(--Border-Neutral, #bbc1d3);
    }
  }
`
